import { ShapeColor } from './types';

export const defaultLabelFormatter = <V extends string | number>(
  value: V | null
): string | number | null => {
  const numberedValue = Number(value);
  if (!isFinite(numberedValue)) {
    return value;
  }
  if (numberedValue >= 1_000_000_000) {
    return (numberedValue / 1_000_000_000).toFixed(1).replace('.', ',') + 'B';
  }
  if (numberedValue >= 1_000_000) {
    return (numberedValue / 1_000_000).toFixed(1).replace('.', ',') + 'M';
  }
  if (numberedValue >= 1_000) {
    return (numberedValue / 1_000).toFixed(1).replace('.', ',') + 'k';
  }
  return value;
};

export const raiseColorShade = (
  color: ShapeColor,
  step: number = 1
): string => {
  const [name, shadeStr] = color.split('.');
  const shade = Number(shadeStr);

  if (shade === 50) {
    return `${name}.${100 * step}`;
  } else if (shade + 100 * step > 900) {
    return `${name}.${shade}`;
  } else {
    return `${name}.${shade + 100 * step}`;
  }
};

type GetShapeColorParams = {
  isHighlighted: boolean;
  isDisabled: boolean;
  isActive: boolean;
  shapeColor: ShapeColor;
};

export const getShapeColor = ({
  isHighlighted,
  isDisabled,
  isActive,
  shapeColor,
}: GetShapeColorParams): string => {
  if (isDisabled) {
    return shapeColor;
  }

  if (isActive) {
    return raiseColorShade(shapeColor);
  }

  if (isHighlighted) {
    return raiseColorShade(shapeColor, 2);
  }

  return shapeColor;
};
